import { inject, provideEnvironmentInitializer } from '@angular/core';

import { PwaUpdateService } from './pwa-update.service';

export const providePwaUpdate = () => [
  PwaUpdateService,
  provideEnvironmentInitializer(() => {
    inject(PwaUpdateService);
  }),
];
